import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AISeoGenerateRequest as SchemaAISeoGenerateRequest } from '../schemas/AISeoGenerateRequest';
import { type GenerateAISeoResponse as SchemaGenerateAISeoResponse } from '../schemas/GenerateAISeoResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const GenerateAISeoForVariantContentType = 'application/json' as const;
export type GenerateAISeoForVariantRequest = SchemaAISeoGenerateRequest;
export type GenerateAISeoForVariantResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная генерация сео текстов
     */
    '200': {
        'application/json': SchemaGenerateAISeoResponse;
    };
};
export type GenerateAISeoForVariantResponseSuccess = GenerateAISeoForVariantResponses['200']['application/json'];
export type GenerateAISeoForVariantSearchParams = undefined;
export type GenerateAISeoForVariantPathParameters = {
    id: string;
};
export const GenerateAISeoForVariantUrl = '/variants/{id}/seo/ai/generate' as const;
export const GenerateAISeoForVariantMethod = 'POST' as const;
export const getGenerateAISeoForVariantUrl = (params: GenerateAISeoForVariantPathParameters) =>
    GenerateAISeoForVariantUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GenerateAISeoForVariantPathParameters) =>
        String(params[param])
    );
